import FetchHelper from '../helpers/fetch_helper';

const ElementsDispatcher = {
  async fetchElements({ elementSetId, latestRevision }) {
    let promise;
    try {
      const url = `element-sets/${elementSetId}/elements?latestRevision=${latestRevision}`;
      promise = await FetchHelper.fetchJson(url, { method: 'GET' });
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: `Could not retrieve Elements for Element Set ${elementSetId}` },
      });
    }
    return promise;
  },

  async saveFRElements({ financingRequestId, elementsValues }) {
    let promise;
    try {
      promise = await FetchHelper.fetchJson(`financing-requests/${financingRequestId}/elements-data`, {
        method: 'post',
        body: { elements: elementsValues },
      });
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: `Could not post element for financing request Id ${financingRequestId}` },
      });
    }
    return promise;
  },

  async retrieveFRElements({ financingRequestId }) {
    let promise;
    try {
      promise = await FetchHelper.fetchJson(`financing-requests/${financingRequestId}/elements-data`, {
        method: 'get',
      });
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: `Could not get elements for financing request Id ${financingRequestId}` },
      });
    }
    return promise;
  },
};

export default ElementsDispatcher;
